"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fendtGlobalColors = void 0;
exports.fendtGlobalColors = {
    primary: {
        brand: '#005E1D',
        white: '#FFFFFF',
        black: '#000000',
        grays: {
            200: '#EAEAEA',
            400: '#C8C8C8',
            600: '#808080',
            800: '#4C4C4C',
        },
    },
    secondary: {
        brand: '#64AA32',
        shades: {
            200: '#84BE86',
            400: '#66AB6A',
            600: '#33813D',
            800: '#154300',
        },
    },
};
